const MAX_CATEGORIES = 3
const MAX_IMAGES_PER_CATEGORY = 6

export {
    MAX_CATEGORIES,
    MAX_IMAGES_PER_CATEGORY,
}
